const defaults = { attribute: 'data-theme' }

function useColorScheme(controller, options = {}) {
  const opts = Object.assign({}, defaults, options)

  function notifyColorScheme(scheme) {
    if (typeof controller.colorSchemeChanged == "function") {
      controller.colorSchemeChanged(scheme)
    } else {
      console.info(`${controller.identifier} does not implement colorSchemeChanged(scheme)`)
    }
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(() => {
      const theme = document.documentElement.getAttribute(opts.attribute)
      notifyColorScheme(theme)
    })
  })

  const colorsSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)')
  function colorSchemeChanged(e) {
    const scheme = e.matches ? 'dark' : 'light'
    notifyColorScheme(scheme)
  }
  colorsSchemeQuery.addEventListener('change', colorSchemeChanged)

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [ opts.attribute ]
  })

  const colorScheme = () => {
    const scheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    const theme = document.documentElement.getAttribute(opts.attribute)

    return theme || scheme
  }
  Object.defineProperty(controller, 'colorScheme', { get: colorScheme })

  const controllerDisconnect = controller.disconnect.bind(controller)
  const disconnect = () => {
    colorsSchemeQuery.removeEventListener('change', colorSchemeChanged)
    observer.disconnect()
    controllerDisconnect()
  }
  Object.assign(controller, { disconnect })
}

export default useColorScheme
